import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useTealiumEventProperties, useTrackPageView } from '@grandvisionhq/svc-tealium/events';
import { useProductDetailContext } from '../../../ProductDetail/Context/ProductDetailContext.js';
import { mapProductToTealiumViewProperties } from '../../mappers/map-product-to-tealium-view-properties.js';

const TealiumPageView = ({ children  })=>{
    const { commonEventProperties , getCommonUserProperties  } = useTealiumEventProperties();
    const { product , activeVariant  } = useProductDetailContext();
    const pdpPageView = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        const commonUserProperties = yield getCommonUserProperties();
        if (!commonUserProperties) return;
        return swcHelpers.objectSpread({}, mapProductToTealiumViewProperties(product, activeVariant), commonEventProperties, commonUserProperties);
    }), // Only need to trigger this page view on initial render & whenever the active variant changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        activeVariant,
        getCommonUserProperties
    ]);
    useTrackPageView(pdpPageView);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};

export { TealiumPageView };
//# sourceMappingURL=TealiumPageView.js.map
